import './styles.scss';

const WithSidebarLayout = ({ Sidebar, children }) => (
    <div className="with-sidebar-layout">
        <div className="with-sidebar-layout__left">{Sidebar}</div>
        <div className="with-sidebar-layout__right">{children}</div>
    </div>
);

export default WithSidebarLayout;
